(() => {
  if (window.__roadSpecVehicleContextLoaded) return;
  window.__roadSpecVehicleContextLoaded = true;

  const storageKey = 'roadspec_vehicle_context_v1';
  const track = (eventName, payload = {}) => {
    try {
      window.Shopify?.analytics?.publish(eventName, payload);
    } catch (_) {}
  };
  const storage = {
    get() {
      try {
        const value = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
        return value && typeof value === 'object' ? value : null;
      } catch (_) {
        return null;
      }
    },
    set(value) {
      try { window.localStorage.setItem(storageKey, JSON.stringify(value)); } catch (_) {}
    },
    clear() {
      try { window.localStorage.removeItem(storageKey); } catch (_) {}
    },
  };

  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const yearNumber = (value) => Number.parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
  const label = (context) => [context?.year, context?.make, context?.model].filter(Boolean).join(' ');

  const contextFitmentState = (record, context) => {
    if (!context?.year || !context?.make || !context?.model) return 'incomplete-context';
    const year = yearNumber(context.year);
    const start = yearNumber(record.yearStart);
    const end = yearNumber(record.yearEnd || record.yearStart);
    const make = normalize(record.make);
    const model = normalize(record.model);
    if (!year || !start || !end || !make || !model) return 'incomplete-listing';
    const yearMatches = year >= start && year <= end;
    const makeMatches = make === normalize(context.make);
    const modelMatches = model === normalize(context.model);
    return yearMatches && makeMatches && modelMatches ? 'match' : 'review';
  };

  const contextMatches = (record, context) => contextFitmentState(record, context) === 'match';

  const contextComplete = (context) => Boolean(context?.year && context?.make && context?.model);

  const queryWithoutVehicleTags = (query) => String(query || '')
    .replace(/(?:^|\s)tag:(?:Year:|Make:)[^\s].*?(?=\s+tag:|$)/gi, '')
    .replace(/\s+/g, ' ')
    .trim();

  const applySearchContext = (context) => {
    const url = new URL(window.location.href);
    if (document.body.dataset.template === 'search' || document.body.dataset.template === 'collection') {
      const currentQuery = queryWithoutVehicleTags(url.searchParams.get('q') || '');
      const tags = [`tag:Year:${context.year}`, `tag:Make:${context.make}`];
      const query = [currentQuery, ...tags, context.model].filter(Boolean).join(' ').trim();
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  };

  const renderProductState = (root, context) => {
    const state = root.querySelector('[data-rsp-vehicle-context-product-state]');
    if (!state) return;
    const record = {
      yearStart: root.dataset.rspProductYearStart,
      yearEnd: root.dataset.rspProductYearEnd,
      make: root.dataset.rspProductMake,
      model: root.dataset.rspProductModel,
    };
    const stateValue = contextFitmentState(record, context);
    if (!context) {
      state.hidden = false;
      state.className = 'rsp-vehicle-context__product-state rsp-vehicle-context__product-state--neutral';
      state.textContent = 'Set a vehicle to check this listing';
    } else if (stateValue === 'match') {
      state.hidden = false;
      state.className = 'rsp-vehicle-context__product-state rsp-vehicle-context__product-state--match';
      state.textContent = 'Catalog application matches your saved vehicle';
    } else if (stateValue === 'incomplete-listing') {
      state.hidden = false;
      state.className = 'rsp-vehicle-context__product-state rsp-vehicle-context__product-state--review';
      state.textContent = 'Listing fitment data is incomplete — review manually';
    } else {
      state.hidden = false;
      state.className = 'rsp-vehicle-context__product-state rsp-vehicle-context__product-state--review';
      state.textContent = contextComplete(context) ? 'Saved vehicle differs — review this listing carefully' : 'Complete your saved vehicle to check fitment';
    }
  };

  const renderSearchPriorityNote = (context) => {
    document.querySelectorAll('[data-rsp-search-priority-note]').forEach((note) => {
      note.hidden = !contextComplete(context);
    });
  };

  const renderFitmentResult = (context) => {
    document.querySelectorAll('[data-rsp-fitment-result]').forEach((result) => {
      const root = result.closest('[data-rsp-product-fitment]');
      const record = {
        yearStart: root?.dataset.rspYearStart,
        yearEnd: root?.dataset.rspYearEnd,
        make: root?.dataset.rspMake,
        model: root?.dataset.rspModel,
      };
      const title = result.querySelector('[data-rsp-fitment-result-title]');
      const message = result.querySelector('[data-rsp-fitment-result-message]');
      let state = 'neutral';
      const fitmentState = contextFitmentState(record, context);
      if (context && fitmentState === 'match') state = 'match';
      else if (context && fitmentState === 'incomplete-listing') state = 'incomplete-listing';
      else if (context) state = contextComplete(context) ? 'review' : 'incomplete';
      result.dataset.state = state;
      if (result.dataset.rspTrackedState !== state) {
        result.dataset.rspTrackedState = state;
        track('roadspec_fitment_state_viewed', {
          state,
          page_type: document.body.dataset.template || 'other',
        });
      }
      if (title) title.textContent = state === 'match' ? 'Catalog application matches your saved vehicle' : state === 'review' ? 'Verify this listing carefully' : state === 'incomplete-listing' ? 'Listing fitment data is incomplete' : state === 'incomplete' ? 'Complete your vehicle details' : 'Fitment check not run yet';
      if (message) message.textContent = state === 'match' ? 'The listed year, make and model align exactly. Confirm the reference number, qualifiers, connectors and photos before ordering.' : state === 'review' ? 'The saved vehicle differs from the application shown here. Review the full vehicle application before ordering.' : state === 'incomplete-listing' ? 'This listing does not contain a complete year, make and model record. Review the reference, qualifiers and photos or ask us before ordering.' : state === 'incomplete' ? 'Save a year, make and model above to compare this listing more clearly.' : 'Save a year, make and model above to compare this listing more clearly.';
    });
  };

  const renderCards = (context) => {
    document.querySelectorAll('[data-rsp-card-fitment]').forEach((card) => {
      const match = card.querySelector('[data-rsp-card-vehicle-match]');
      if (!match) return;
      const record = {
        yearStart: card.dataset.rspCardYearStart,
        yearEnd: card.dataset.rspCardYearEnd,
        make: card.dataset.rspCardMake,
        model: card.dataset.rspCardModel,
      };
      const fitmentState = contextFitmentState(record, context);
      const isMatch = fitmentState === 'match';
      match.hidden = !isMatch;
      card.classList.toggle('rsp-card--vehicle-match', isMatch);
      card.classList.toggle('rsp-card--vehicle-review', Boolean(context) && fitmentState !== 'match');
      card.dataset.rspCardMatchState = fitmentState;
    });

    const grid = document.querySelector('.rsp-fitment-grid');
    if (!grid || !context) return;
    const items = [...grid.children];
    const matched = items.filter((item) => item.querySelector('[data-rsp-card-fitment][data-rsp-card-match-state="match"]'));
    matched.reverse().forEach((item) => grid.prepend(item));
  };

  document.querySelectorAll('[data-rsp-vehicle-context]').forEach((root) => {
    const form = root.querySelector('[data-rsp-vehicle-context-form]');
    const panel = root.querySelector('[data-rsp-vehicle-context-panel]');
    const toggle = root.querySelector('[data-rsp-vehicle-context-toggle]');
    const clearButtons = root.querySelectorAll('[data-rsp-vehicle-context-clear]');
    const error = root.querySelector('[data-rsp-vehicle-context-error]');
    const summary = root.querySelector('[data-rsp-vehicle-context-summary]');
    const help = root.querySelector('[data-rsp-vehicle-context-help]');
    const year = root.querySelector('[data-rsp-vehicle-year]');
    const make = root.querySelector('[data-rsp-vehicle-make]');
    const model = root.querySelector('[data-rsp-vehicle-model]');

    const render = () => {
      const context = storage.get();
      if (year) year.value = context?.year || '';
      if (make) make.value = context?.make || '';
      if (model) model.value = context?.model || '';
      if (summary) summary.textContent = context ? label(context) : 'Set your vehicle';
      if (help) help.textContent = context ? 'Use this vehicle context while reviewing fitment and search results.' : 'Save a year, make and model to compare listings more clearly as you browse.';
      if (toggle) toggle.textContent = context ? 'Change vehicle' : 'Set vehicle';
      clearButtons.forEach((button) => { button.hidden = !context; });
      renderProductState(root, context);
      renderFitmentResult(context);
      renderCards(context);
      renderSearchPriorityNote(context);
    };

    toggle?.addEventListener('click', () => {
      const expanded = !panel.hidden;
      panel.hidden = expanded;
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (!expanded) window.setTimeout(() => year?.focus(), 0);
    });
    clearButtons.forEach((button) => button.addEventListener('click', () => {
      storage.clear();
      render();
      window.dispatchEvent(new CustomEvent('roadspec:vehicle-context-updated'));
      track('roadspec_vehicle_context_cleared', { page_type: document.body.dataset.template || 'other' });
    }));
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const context = { year: year?.value || '', make: make?.value || '', model: model?.value?.trim() || '' };
      if (!contextComplete(context)) {
        form.setAttribute('data-rsp-invalid', 'true');
        if (error) error.hidden = false;
        [year, make, model].find((field) => !field?.value)?.focus();
        return;
      }
      form.removeAttribute('data-rsp-invalid');
      if (error) error.hidden = true;
      storage.set(context);
      panel.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
      render();
      window.dispatchEvent(new CustomEvent('roadspec:vehicle-context-updated'));
      track('roadspec_vehicle_context_saved', { year: context.year, make: context.make, has_model: true, page_type: document.body.dataset.template || 'other' });
      applySearchContext(context);
    });
    [year, make, model].forEach((field) => field?.addEventListener('input', () => { form?.removeAttribute('data-rsp-invalid'); if (error) error.hidden = true; }));
    [year, make, model].forEach((field) => field?.addEventListener('change', () => { form?.removeAttribute('data-rsp-invalid'); if (error) error.hidden = true; }));
    render();
  });

  window.addEventListener('roadspec:vehicle-context-updated', () => {
    const context = storage.get();
    renderFitmentResult(context);
    renderCards(context);
    renderSearchPriorityNote(context);
  });
})();
